import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const CreateNewProject = React.lazy(() => import('.'));

export const createNewProjectRoutes = [
  new Route({
    path: 'create-new-project',
    element: CreateNewProject,
    children: [],
  }),
];
